/* ============================================
   MODAL BATIDOR ELÉCTRICO - OHMYGOODS
   Post-Add-to-Cart Upsell Modal
   Versión: 1.0.7 FINAL - Batidor Eléctrico
   ============================================ */
(function() {
  'use strict';

  // ===== CONFIGURACIÓN =====
  const CONFIG = {
    modalId: 'matcha-upsell-modal',
    
    product: {
      variantId: 49609281143084,
      price: 1495,
      discount: 30,
      image: 'https://cdn.shopify.com/s/files/1/0838/4066/3852/files/01-batidor-mano.jpg?v=1759396740'
    },
    
    texts: {
      badge: 'Oferta Limitada · {{number}} vendidos hoy',
      productName: 'Batidor Eléctrico',
      productTagline: 'Prepara tus bebidas y suplementos en segundos',
      pricingLabel: 'Solo ahora por',
      savingsText: 'Ahorras {{savings}} (-{{percent}}%)',
      badge1: 'Espuma en segundos',
      badge2: 'Sin grumos',
      badge3: 'Mejor preparación',
      btnSecondary: 'Ahora no',
      btnPrimary: 'Añadir Oferta'
    },
    
    selectors: {
      cartDrawer: '.corner-widget-wrapper',
      cartToggle: '.wt-cart__trigger',
      closeDrawerBtn: 'button[aria-label="corner-cowi-outside-close-button"]'
    },
    
    timing: {
      drawerClose: 250,
      modalInsert: 50
    },
    
    trending: {
      min: 101,
      max: 174
    },
    
    zIndex: 2147483647,
    sessionKey: 'batidor_upsell_modal_shown'
  };

  // ===== ESTADOS GLOBALES =====
  let modalState = {
    processing: false,
    isOpen: false,
    isInserting: false,
    abortController: null
  };

  // ===== ESTILOS =====
  const STYLES = {
    css: `
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

.modal-overlay {
  position: fixed !important;
  inset: 0 !important;
  background: rgba(0, 0, 0, 0.65) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: ${CONFIG.zIndex} !important;
  animation: fadeIn 0.25s ease !important;
  backdrop-filter: blur(4px) !important;
  padding: 20px !important;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeOut {
  from { opacity: 1; }
  to { opacity: 0; }
}

.modal-overlay .modal {
  background: #F5F1E8;
  border-radius: 24px;
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
  max-height: calc(100vh - 40px);
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  margin: 0;
}

@keyframes slideUp {
  from {
    transform: translateY(50px) scale(0.94);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

#${CONFIG.modalId}-close {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  min-height: 36px !important;
  max-width: 36px !important;
  max-height: 36px !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: none !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 10 !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  padding: 0 !important;
}

#${CONFIG.modalId}-close:hover {
  background: white !important;
  transform: scale(1.1) !important;
}

#${CONFIG.modalId}-close::before,
#${CONFIG.modalId}-close::after {
  content: '' !important;
  position: absolute !important;
  width: 16px !important;
  height: 2.5px !important;
  background: #666 !important;
  border-radius: 2px !important;
}

#${CONFIG.modalId}-close::before { 
  transform: rotate(45deg) !important; 
}

#${CONFIG.modalId}-close::after { 
  transform: rotate(-45deg) !important; 
}

.modal-overlay .modal-top {
  padding: 24px 26px 0px 26px;
  text-align: center;
  background: linear-gradient(180deg, #FFFDF7 0%, #F5F1E8 100%);
  border-radius: 24px 24px 0 0;
}

.modal-overlay .top-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 700;
  background: linear-gradient(135deg, #FF8C42 0%, #ec6635 100%);
  background-size: 200% 100%;
  color: white;
  margin-top: 12px;
  margin-bottom: 8px;
  box-shadow: 0 3px 10px rgba(236, 102, 53, 0.4);
  text-transform: none;
  letter-spacing: 0.5px;
  animation: shine 4s ease-in-out infinite;
}

@keyframes shine {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.modal-overlay .product-name {
  font-size: 26px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 6px;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.modal-overlay .product-tagline {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  font-weight: 400;
  font-style: italic;
  opacity: 0.9;
  margin-bottom: 8px;
}

.modal-overlay .modal-image {
  padding: 12px 46px 0px 46px;
  background: #F5F1E8;
}

.modal-overlay .product-image-container {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: linear-gradient(135deg, #e8e4d9 0%, #d4cfc0 100%);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  margin: 0 auto;
}

.modal-overlay .product-image-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.modal-overlay .pricing-section {
  padding: 12px 34px 12px 34px;
  background: #F5F1E8;
  text-align: center;
}

.modal-overlay .pricing-label {
  font-size: 12px;
  color: #888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.modal-overlay .pricing-line {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 8px;
}

.modal-overlay .price-original {
  font-size: 15px;
  color: #999;
  text-decoration: line-through;
  font-weight: 500;
}

.modal-overlay .price-final {
  font-size: 28px;
  font-weight: 700;
  color: #ec6635;
  letter-spacing: -1px;
  line-height: 1;
}

.modal-overlay .savings-line {
  font-size: 13px;
  font-weight: 700;
  color: #c54928;
}

.modal-overlay .savings-highlight {
  display: inline-block;
  padding: 3px 10px;
  background: linear-gradient(135deg, #FFE8DC 0%, #FFD4C4 100%);
  border: 1px solid rgba(236, 102, 53, 0.2);
  border-radius: 10px;
  animation: subtle-pulse 3s ease-in-out infinite;
}

@keyframes subtle-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
}

.modal-overlay .micro-badges {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 12px 26px 14px 26px;
  background: #F5F1E8;
  flex-wrap: nowrap;
}

.modal-overlay .micro-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #555;
  font-weight: 600;
  white-space: nowrap;
}

.modal-overlay .micro-badge::before {
  content: '✓';
  color: #ec6635;
  font-weight: 800;
  font-size: 12px;
  flex-shrink: 0;
}

.modal-overlay .modal-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 0 26px 22px 26px;
  background: #F5F1E8;
}

.modal-overlay .cta-secondary {
  padding: 12px 16px;
  background: white;
  border: 2px solid #D4CFC0;
  color: #666;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  line-height: 1.3;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.modal-overlay .cta-secondary:hover {
  border-color: #ec6635;
  color: #c54928;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.modal-overlay .cta-primary {
  padding: 12px 16px;
  background: linear-gradient(135deg, #ec6635 0%, #d94d1f 100%);
  color: white;
  border: 2px solid transparent;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(236, 102, 53, 0.35);
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  line-height: 1.3;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.modal-overlay .cta-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(236, 102, 53, 0.45);
}

.modal-overlay .cta-primary:active {
  transform: translateY(0);
}

@media (min-width: 769px) {
  .modal-overlay {
    padding-right: 460px;
    justify-content: center;
  }

  .modal-overlay .modal {
    max-width: 480px;
  }

  .modal-overlay .modal-top {
    padding: 28px 30px 0px 30px;
  }

  .modal-overlay .top-badge {
    font-size: 12px;
    padding: 7px 16px;
    margin-bottom: 10px;
  }

  .modal-overlay .product-name {
    font-size: 30px;
    font-weight: 800;
  }

  .modal-overlay .product-tagline {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .modal-overlay .modal-image {
    padding: 12px 32px 0px 32px;
  }

  .modal-overlay .pricing-section {
    padding: 16px 38px 16px 38px;
  }

  .modal-overlay .price-original {
    font-size: 16px;
  }

  .modal-overlay .price-final {
    font-size: 32px;
  }

  .modal-overlay .micro-badges {
    padding: 14px 30px 16px 30px;
    gap: 12px;
  }

  .modal-overlay .micro-badge {
    font-size: 11px;
  }

  .modal-overlay .modal-actions {
    padding: 0 30px 26px 30px;
    gap: 12px;
  }

  .modal-overlay .cta-secondary,
  .modal-overlay .cta-primary {
    padding: 14px 18px;
    font-size: 17px;
    min-height: 54px;
  }
}

@media (max-width: 480px) {
  .modal-overlay {
    padding: 12px;
  }

  .modal-overlay .modal {
    max-width: 100%;
    border-radius: 20px;
    max-height: calc(100vh - 24px);
  }

  .modal-overlay .modal-top {
    padding: 22px 24px 0px 24px;
    border-radius: 20px 20px 0 0;
  }

  .modal-overlay .top-badge {
    margin-bottom: 6px;
  }

  .modal-overlay .product-name {
    font-size: 24px;
    font-weight: 800;
  }

  .modal-overlay .product-tagline {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .modal-overlay .modal-image {
    padding: 10px 40px 0px 40px;
  }

  .modal-overlay .product-image-container {
    padding-bottom: 100%;
    border-radius: 12px;
  }

  .modal-overlay .pricing-section {
    padding: 12px 30px 10px 30px;
  }

  .modal-overlay .price-final {
    font-size: 26px;
  }

  .modal-overlay .micro-badges {
    padding: 10px 24px 12px 24px;
    gap: 8px;
  }

  .modal-overlay .micro-badge {
    font-size: 9.5px;
  }

  .modal-overlay .modal-actions {
    padding: 0 24px 20px 24px;
    gap: 8px;
  }

  .modal-overlay .cta-primary,
  .modal-overlay .cta-secondary {
    padding: 10px 12px;
    font-size: 15px;
    min-height: 48px;
  }
}

@media (max-width: 360px) {
  .modal-overlay {
    padding: 8px;
  }

  .modal-overlay .modal {
    max-height: calc(100vh - 16px);
  }

  .modal-overlay .top-badge {
    white-space: nowrap;
  }

  .modal-overlay .modal-image {
    padding: 10px 30px 0px 30px;
  }

  .modal-overlay .product-name {
    font-size: 22px;
  }

  .modal-overlay .product-tagline {
    font-size: 12px;
  }

  .modal-overlay .cta-primary,
  .modal-overlay .cta-secondary {
    padding: 10px 10px;
    font-size: 14px;
    min-height: 46px;
  }

  .modal-overlay .micro-badges {
    gap: 6px;
  }

  .modal-overlay .micro-badge {
    font-size: 9px;
  }
}

@media (min-width: 769px) and (max-height: 950px) {
  .modal-overlay .modal-top {
    padding: 24px 30px 0px 30px;
  }

  .modal-overlay .modal-image {
    padding: 10px 32px 0px 32px;
  }

  .modal-overlay .product-image-container {
    padding-bottom: 90%;
  }

  .modal-overlay .pricing-section {
    padding: 14px 38px 14px 38px;
  }

  .modal-overlay .micro-badges {
    padding: 12px 30px 14px 30px;
  }

  .modal-overlay .modal-actions {
    padding: 0 30px 24px 30px;
  }
}

@media (min-width: 769px) and (max-height: 850px) {
  .modal-overlay .modal-top {
    padding: 20px 30px 0px 30px;
  }

  .modal-overlay .modal-image {
    padding: 8px 32px 0px 32px;
  }

  .modal-overlay .product-image-container {
    padding-bottom: 80%;
  }

  .modal-overlay .pricing-section {
    padding: 11px 38px 11px 38px;
  }

  .modal-overlay .micro-badges {
    padding: 9px 30px 11px 30px;
  }

  .modal-overlay .modal-actions {
    padding: 0 30px 19px 30px;
  }
}

@media (min-width: 769px) and (max-height: 750px) {
  .modal-overlay .modal-top {
    padding: 16px 30px 0px 30px;
  }

  .modal-overlay .top-badge {
    padding: 6px 14px;
    font-size: 11px;
  }

  .modal-overlay .product-name {
    font-size: 28px;
  }

  .modal-overlay .product-tagline {
    font-size: 14px;
  }

  .modal-overlay .modal-image {
    padding: 5px 32px 0px 32px;
  }

  .modal-overlay .product-image-container {
    padding-bottom: 70%;
  }

  .modal-overlay .pricing-section {
    padding: 9px 38px 9px 38px;
  }

  .modal-overlay .pricing-label {
    font-size: 11px;
  }

  .modal-overlay .price-final {
    font-size: 30px;
  }

  .modal-overlay .micro-badges {
    padding: 7px 30px 9px 30px;
    gap: 10px;
  }

  .modal-overlay .micro-badge {
    font-size: 10px;
  }

  .modal-overlay .modal-actions {
    padding: 0 30px 15px 30px;
    gap: 10px;
  }

  .modal-overlay .cta-primary,
  .modal-overlay .cta-secondary {
    padding: 12px 16px;
    font-size: 16px;
    min-height: 50px;
  }
}

@media (min-width: 769px) and (max-height: 650px) {
  .modal-overlay .modal-top {
    padding: 13px 30px 0px 30px;
  }

  .modal-overlay .top-badge {
    padding: 5px 12px;
    font-size: 10px;
    margin-top: 7px;
    margin-bottom: 4px;
  }

  .modal-overlay .product-name {
    font-size: 26px;
    margin-bottom: 3px;
  }

  .modal-overlay .product-tagline {
    font-size: 13px;
    margin-bottom: 4px;
  }

  .modal-overlay .modal-image {
    padding: 3px 32px 0px 32px;
  }

  .modal-overlay .product-image-container {
    padding-bottom: 60%;
  }

  .modal-overlay .pricing-section {
    padding: 7px 38px 7px 38px;
  }

  .modal-overlay .pricing-label {
    font-size: 10px;
    margin-bottom: 4px;
  }

  .modal-overlay .pricing-line {
    gap: 8px;
    margin-bottom: 4px;
  }

  .modal-overlay .price-original {
    font-size: 14px;
  }

  .modal-overlay .price-final {
    font-size: 28px;
  }

  .modal-overlay .savings-line {
    font-size: 11px;
  }

  .modal-overlay .micro-badges {
    padding: 5px 30px 7px 30px;
    gap: 8px;
  }

  .modal-overlay .micro-badge {
    font-size: 9px;
  }

  .modal-overlay .modal-actions {
    padding: 0 30px 13px 30px;
    gap: 8px;
  }

  .modal-overlay .cta-primary,
  .modal-overlay .cta-secondary {
    padding: 11px 15px;
    font-size: 15px;
    min-height: 46px;
  }
}

@media (min-width: 769px) and (max-height: 550px) {
  .modal-overlay .modal-top {
    padding: 11px 30px 0px 30px;
  }

  .modal-overlay .top-badge {
    padding: 4px 10px;
    font-size: 9px;
    margin-top: 5px;
    margin-bottom: 3px;
  }

  .modal-overlay .product-name {
    font-size: 24px;
    margin-bottom: 2px;
  }

  .modal-overlay .product-tagline {
    font-size: 12px;
    margin-bottom: 3px;
  }

  .modal-overlay .modal-image {
    padding: 2px 32px 0px 32px;
  }

  .modal-overlay .product-image-container {
    padding-bottom: 50%;
  }

  .modal-overlay .pricing-section {
    padding: 5px 38px 5px 38px;
  }

  .modal-overlay .pricing-label {
    font-size: 9px;
    margin-bottom: 3px;
  }

  .modal-overlay .pricing-line {
    gap: 6px;
    margin-bottom: 3px;
  }

  .modal-overlay .price-original {
    font-size: 13px;
  }

  .modal-overlay .price-final {
    font-size: 26px;
  }

  .modal-overlay .savings-line {
    font-size: 10px;
  }

  .modal-overlay .savings-highlight {
    padding: 2px 8px;
  }

  .modal-overlay .micro-badges {
    padding: 4px 30px 6px 30px;
    gap: 6px;
  }

  .modal-overlay .micro-badge {
    font-size: 8px;
    gap: 3px;
  }

  .modal-overlay .modal-actions {
    padding: 0 30px 11px 30px;
    gap: 6px;
  }

  .modal-overlay .cta-primary,
  .modal-overlay .cta-secondary {
    padding: 10px 14px;
    font-size: 14px;
    min-height: 44px;
  }
}

@media (min-width: 769px) and (max-height: 500px) {
  .modal-overlay .modal-top {
    padding: 9px 30px 0px 30px;
  }

  .modal-overlay .top-badge {
    padding: 3px 8px;
    font-size: 8px;
    margin-top: 4px;
    margin-bottom: 2px;
  }

  .modal-overlay .product-name {
    font-size: 22px;
    margin-bottom: 2px;
  }

  .modal-overlay .product-tagline {
    font-size: 11px;
    margin-bottom: 2px;
  }

  .modal-overlay .modal-image {
    padding: 1px 32px 0px 32px;
  }

  .modal-overlay .product-image-container {
    padding-bottom: 45%;
  }

  .modal-overlay .pricing-section {
    padding: 4px 38px 4px 38px;
  }

  .modal-overlay .pricing-label {
    font-size: 9px;
    margin-bottom: 2px;
  }

  .modal-overlay .pricing-line {
    gap: 5px;
    margin-bottom: 2px;
  }

  .modal-overlay .price-original {
    font-size: 12px;
  }

  .modal-overlay .price-final {
    font-size: 24px;
  }

  .modal-overlay .savings-line {
    font-size: 9px;
  }

  .modal-overlay .savings-highlight {
    padding: 2px 6px;
  }

  .modal-overlay .micro-badges {
    padding: 3px 30px 5px 30px;
    gap: 5px;
  }

  .modal-overlay .micro-badge {
    font-size: 7px;
    gap: 2px;
  }

  .modal-overlay .modal-actions {
    padding: 0 30px 9px 30px;
    gap: 5px;
  }

  .modal-overlay .cta-primary,
  .modal-overlay .cta-secondary {
    padding: 9px 12px;
    font-size: 13px;
    min-height: 42px;
  }
}
    `
  };

  // ===== FUNCIONES AUXILIARES =====
  
  function injectStyles() {
    if (document.getElementById(`${CONFIG.modalId}-styles`)) return;
    
    const style = document.createElement('style');
    style.id = `${CONFIG.modalId}-styles`;
    style.textContent = STYLES.css;
    document.head.appendChild(style);
  }

  function hasModalBeenShown() {
    return sessionStorage.getItem(CONFIG.sessionKey) === 'true';
  }

  function markModalAsShown() {
    sessionStorage.setItem(CONFIG.sessionKey, 'true');
  }

  async function isProductInCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const isInCart = cart.items.some(item => item.id === CONFIG.product.variantId);
      
      return isInCart;
    } catch (error) {
      console.error('❌ Error verificando carrito:', error);
      return false;
    }
  }

  function getRandomTrending() {
    return Math.floor(Math.random() * (CONFIG.trending.max - CONFIG.trending.min + 1)) + CONFIG.trending.min;
  }

  function calculateDiscount() {
    const discountedPrice = Math.round(CONFIG.product.price * (1 - CONFIG.product.discount / 100));
    const savings = CONFIG.product.price - discountedPrice;
    
    return {
      originalPrice: CONFIG.product.price,
      discountedPrice: discountedPrice,
      savings: savings,
      discountPercent: CONFIG.product.discount
    };
  }

  function formatPrice(cents) {
    const value = (cents / 100).toFixed(2);
    return `${value.replace('.', ',')}€`;
  }

  function findDrawerCloseButton() {
    let btn = document.querySelector(CONFIG.selectors.closeDrawerBtn);
    if (btn) return btn;
    
    const drawer = document.querySelector(CONFIG.selectors.cartDrawer);
    if (drawer) {
      btn = drawer.querySelector('button[aria-label*="close"]');
      if (btn) return btn;
    }
    
    btn = document.querySelector('#CartDrawer button[aria-label*="close"]');
    return btn;
  }

  function createModalHTML() {
    const trendingNumber = getRandomTrending();
    const pricing = calculateDiscount();
    
    const badgeText = CONFIG.texts.badge.replace('{{number}}', trendingNumber);
    const savingsText = CONFIG.texts.savingsText
      .replace('{{savings}}', formatPrice(pricing.savings))
      .replace('{{percent}}', pricing.discountPercent);
    
    return `
      <div class="modal" id="${CONFIG.modalId}-content">
        <button id="${CONFIG.modalId}-close" aria-label="Cerrar"></button>

        <div class="modal-top">
          <div class="top-badge">${badgeText}</div>
          <h2 class="product-name">${CONFIG.texts.productName}</h2>
          <p class="product-tagline">${CONFIG.texts.productTagline}</p>
        </div>

        <div class="modal-image">
          <div class="product-image-container">
            <img src="${CONFIG.product.image}" alt="${CONFIG.texts.productName}">
          </div>
        </div>

        <div class="pricing-section">
          <div class="pricing-label">${CONFIG.texts.pricingLabel}</div>
          <div class="pricing-line">
            <span class="price-original">${formatPrice(pricing.originalPrice)}</span>
            <span class="price-final">${formatPrice(pricing.discountedPrice)}</span>
          </div>
          <div class="savings-line">
            <span class="savings-highlight">${savingsText}</span>
          </div>
        </div>

        <div class="micro-badges">
          <span class="micro-badge">${CONFIG.texts.badge1}</span>
          <span class="micro-badge">${CONFIG.texts.badge2}</span>
          <span class="micro-badge">${CONFIG.texts.badge3}</span>
        </div>

        <div class="modal-actions">
          <button class="cta-secondary" id="${CONFIG.modalId}-skip">${CONFIG.texts.btnSecondary}</button>
          <button class="cta-primary" id="${CONFIG.modalId}-add">${CONFIG.texts.btnPrimary}</button>
        </div>
      </div>
    `;
  }

  // ===== GESTIÓN DEL MODAL =====

  async function insertModal() {
    if (modalState.isInserting) return;
    if (hasModalBeenShown()) return;
    if (document.getElementById(`${CONFIG.modalId}-overlay`)) return;
    
    modalState.isInserting = true;
    
    try {
      markModalAsShown();
      
      const modalOverlay = document.createElement('div');
      modalOverlay.id = `${CONFIG.modalId}-overlay`;
      modalOverlay.className = 'modal-overlay';
      modalOverlay.innerHTML = createModalHTML();
      
      requestAnimationFrame(() => {
        document.body.appendChild(modalOverlay);
        modalState.isOpen = true;
        
        requestAnimationFrame(() => {
          initializeModalFunctionality();
        });
      });
      
      console.log('✅ Modal Batidor Eléctrico mostrado');
    } catch (error) {
      console.error('❌ Error insertando modal:', error);
    } finally {
      modalState.isInserting = false;
    }
  }

  function initializeModalFunctionality() {
    const overlay = document.getElementById(`${CONFIG.modalId}-overlay`);
    const closeBtn = document.getElementById(`${CONFIG.modalId}-close`);
    const skipBtn = document.getElementById(`${CONFIG.modalId}-skip`);
    const addBtn = document.getElementById(`${CONFIG.modalId}-add`);
    
    if (!overlay || !closeBtn || !skipBtn || !addBtn) {
      console.error('❌ Elementos del modal no encontrados');
      return;
    }
    
    const abortController = new AbortController();
    modalState.abortController = abortController;
    const signal = abortController.signal;
    
    function closeModal() {
      if (modalState.abortController) {
        modalState.abortController.abort();
        modalState.abortController = null;
      }
      
      overlay.style.animation = 'fadeOut 0.2s ease';
      setTimeout(() => {
        overlay.remove();
        modalState.isOpen = false;
      }, 200);
    }
    
    function redirectToCart() {
      const cartDrawerToggle = document.querySelector(CONFIG.selectors.cartToggle);
      if (cartDrawerToggle) {
        closeModal();
        setTimeout(() => cartDrawerToggle.click(), 100);
      } else {
        window.location.href = '/cart';
      }
    }
    
    async function processAction(shouldAddProduct) {
      if (modalState.processing) return;
      
      modalState.processing = true;
      
      try {
        if (shouldAddProduct) {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: CONFIG.product.variantId,
              quantity: 1
            })
          });
          
          if (response.ok) {
            console.log('✅ Batidor Eléctrico añadido al carrito');
            redirectToCart();
          } else {
            console.error('❌ Error al añadir producto');
          }
        } else {
          redirectToCart();
        }
      } catch (error) {
        console.error('❌ Error en la petición:', error);
      } finally {
        modalState.processing = false;
      }
    }
    
    function handleKeydown(e) {
      if (!modalState.isOpen) return;
      
      if (e.key === 'Escape') {
        redirectToCart();
      }
      
      if (e.key === 'Enter' && !modalState.processing) {
        processAction(true);
      }
    }
    
    closeBtn.addEventListener('click', () => redirectToCart(), { signal });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) redirectToCart();
    }, { signal });
    skipBtn.addEventListener('click', () => processAction(false), { signal });
    addBtn.addEventListener('click', () => processAction(true), { signal });
    document.addEventListener('keydown', handleKeydown, { signal });
    
    console.log('✅ Modal inicializado correctamente');
  }

  function closeDrawerAndShowModal() {
    if (modalState.isInserting || hasModalBeenShown() || document.getElementById(`${CONFIG.modalId}-overlay`)) {
      console.log('⚠️ Modal no se mostrará (ya mostrado esta sesión), manteniendo drawer abierto');
      return;
    }
    
    const closeBtn = findDrawerCloseButton();
    if (closeBtn) {
      console.log('✅ Cerrando cart drawer');
      closeBtn.click();
    }
    
    requestAnimationFrame(() => {
      if (!modalState.isOpen && !modalState.isInserting) {
        insertModal();
      }
    });
  }

  // ===== INTERCEPTACIÓN DE ADD TO CART =====

  function interceptAddToCart() {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      const url = args[0];
      
      if (url && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
        return originalFetch.apply(this, args).then(response => {
          if (response.ok) {
            console.log('✅ Producto añadido al carrito, preparando modal');
            setTimeout(closeDrawerAndShowModal, CONFIG.timing.drawerClose);
          }
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };
    
    const originalXHROpen = XMLHttpRequest.prototype.open;
    
    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      if (url && url.includes('/cart/add')) {
        this.addEventListener('load', function() {
          if (this.status >= 200 && this.status < 300) {
            console.log('✅ Producto añadido (XHR), preparando modal');
            setTimeout(closeDrawerAndShowModal, CONFIG.timing.drawerClose);
          }
        });
      }
      
      return originalXHROpen.apply(this, [method, url, ...args]);
    };
  }

  // ===== INICIALIZACIÓN =====

  function init() {
    if (document.getElementById(`${CONFIG.modalId}-overlay`)) return;
    
    try {
      injectStyles();
      interceptAddToCart();
      console.log('🚀 Modal Batidor Eléctrico: Sistema inicializado (v1.0.7)');
    } catch (error) {
      console.error('❌ Error inicializando modal:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();